import React from 'react';
import './index.scss';
import { reviewsFormat } from '@op/utils/value';
import { useIntl } from 'umi';
import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import { useGameOperations } from '@op/utils/game';
import { Bubble } from 'tea-component';
const suffix = ['st', 'nd', 'rd'];

export function TrendCardTips({
  rankList,
  isLeft = false,
  valueFormat = reviewsFormat,
  currentRank = 0,
  title = 'Mentions',
  showRankFlag,
  canNavigateToGame,
  rankKey,
  gameTitle = 'Game',
  noGoToGame = false,
}: any) {
  const { formatMessage } = useIntl();

  const { handleChangeGame } = useGameOperations();

  const isSafari = () => {
    const userAgent = navigator.userAgent;
    return userAgent.includes('Safari') && !userAgent.includes('Chrome');
  };
  const handleMouseOver = () => {
    if (isSafari()) {
      const pageMetricsElement = document.querySelector('.dbo-page-metrics');
      if (pageMetricsElement) {
        (pageMetricsElement as HTMLElement).style.paddingRight = '8px';
        (pageMetricsElement as HTMLElement).style.overflowY = 'hidden';
      }
    }
  };
  const handleMouseOut = () => {
    if (isSafari()) {
      const pageMetricsElement = document.querySelector('.dbo-page-metrics');
      if (pageMetricsElement) {
        (pageMetricsElement as HTMLElement).style.paddingRight = '0';
        (pageMetricsElement as HTMLElement).style.overflowY = 'auto';
      }
    }
  };

  return (
    <div
      className={`dbo-rank-cardtips ${isLeft && 'dbo-rank-cardtips--left'}`}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      <div className="dbo-rank-cardtips-header">
        <div className="dbo-rank-cardtips-th  dbo-rank-cardtips-th-rank">
          {formatMessage({ id: 'Rank' })}
        </div>
        <div className="dbo-rank-cardtips-th  dbo-rank-cardtips-th-img">
          {formatMessage({ id: gameTitle })}
        </div>
        <div className="dbo-rank-cardtips-th  dbo-rank-cardtips-th-name">
          {/* 游戏名称 */}
        </div>
        <div className="dbo-rank-cardtips-th  dbo-rank-cardtips-th-num">
          {formatMessage({ id: title })}
        </div>
      </div>
      <div className="dbo-rank-cardtips-body">
        <div className="dbo-rank-cardtips-list">
          {rankList.map(
            (
              item: {
                edition_unified_id: string;
                cover: string;
                value: number;
                entity_type: string;
                entity_name: string;
                [key: string]: any;
              },
              index: number,
            ) => {
              const {
                edition_unified_id,
                value,
                entity_name: name,
                entity_type,
              } = item || {};

              const rank = rankKey ? item[rankKey] : index + 1;

              const className = currentRank === rank ? 'active' : '';
              const whiteColor = showRankFlag ? 'white' : '';
              // todo 判断是否为pc游戏还是移动游戏
              const isMobile = entity_type === 'mobile';

              const valueInfo = valueFormat(value);

              return (
                // 高亮状态active
                <div
                  className={`dbo-rank-cardtips-item ${className} ${whiteColor} ${noGoToGame ? '--no-links' : ''}`}
                  key={edition_unified_id}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (noGoToGame) return;
                    if (currentRank !== rank || canNavigateToGame) {
                      handleChangeGame(item, true);
                    }
                  }}
                >
                  <div className="dbo-rank-cardtips-td dbo-rank-cardtips-td-rank">
                    {valueInfo === '-' ? (
                      '-'
                    ) : (
                      <>
                        {rank}
                        {suffix[rank - 1] || 'th'}
                      </>
                    )}
                  </div>
                  <div className="dbo-rank-cardtips-td dbo-rank-cardtips-td-img">
                    <RenderGameIcon gameInfo={item}></RenderGameIcon>
                  </div>
                  <div className="dbo-rank-cardtips-td dbo-rank-cardtips-td-name">
                    {name || '-'}
                  </div>
                  <div className="dbo-rank-cardtips-td dbo-rank-cardtips-td-num">
                    {valueInfo}
                  </div>
                </div>
              );
            },
          )}
        </div>
      </div>
    </div>
  );
}

export function RankKeyMeticsItem({
  getRankList,
  valueKey,
  list: defaultList = [],
  rank: defaultRank = 0,
  noShow,
  valueFormat = reviewsFormat,
  title,
  logId,
  navigateLogId,
  canNavigateToGame,
  mustShowRank,
  rankKey,
  gameTitle,
  noGoToGame,
}: {
  getRankList?: any;
  valueKey?: any;
  list?: Array<any>;
  rank?: number;
  noShow: boolean;
  valueFormat?: (val: number) => number | string;
  title: string;
  logId?: string;
  navigateLogId?: string;
  canNavigateToGame?: boolean;
  mustShowRank?: boolean;
  rankKey?: string;
  gameTitle?: string;
  noGoToGame?: boolean;
}) {
  const { list, rank } = getRankList?.(valueKey) || {
    list: defaultList,
    rank: defaultRank,
  };

  const showRankFlag = list.every((item: any) => {
    return valueFormat(item.value) === '-';
  });
  if (!noShow) return null;

  const suf = suffix[rank - 1] || 'th';

  const showRank = valueFormat(list?.[rank - 1]?.value) === '-';

  return (
    <div
      className="rank-key-metrics-item-wrapper"
      onMouseEnter={() => (logId ? buriedBtnPoint(logId, title) : null)}
    >
      {rank > 0 && (
        <Bubble
          className="dbo-nostyle-wrap"
          placement="right"
          content={
            <TrendCardTips
              valueFormat={valueFormat}
              rankList={list}
              currentRank={rank}
              title={title}
              gameTitle={gameTitle}
              rankKey={rankKey}
              noGoToGame={noGoToGame}
              logId={navigateLogId}
              showRankFlag={showRankFlag}
              canNavigateToGame={canNavigateToGame}
            ></TrendCardTips>
          }
        >
          <div className="dbo-compare-operation">
            <div
              className={`dbo-compare-operation-rank ${
                showRank ? '' : `rank-${rank}`
              }`}
            >
              <span>
                {showRank && !mustShowRank ? (
                  '-'
                ) : (
                  <>
                    {rank}
                    {rank < 10 && suf}
                  </>
                )}
              </span>
            </div>
          </div>
        </Bubble>
      )}
    </div>
  );
}
